import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

// Shared shell for the profile rail's cards (identity + badges) so both keep
// the same padding, radius, and border as the rest of the app's surfaces.
export const RailCard = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: Number(theme.shape.borderRadius) * 2,
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
}))

export const RAIL_WIDTH = 296

// Two-column profile: fixed-width rail, lists take the remaining space.
// Collapses to a single column on tablet and below.
export const ProfileLayout = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: `${RAIL_WIDTH}px minmax(0, 1fr)`,
  gap: theme.spacing(3),
  alignItems: 'start',
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'minmax(0, 1fr)',
  },
}))

// Both cards stick as one unit and simply pin in place - no inner scrollbar in
// the normal case. `auto` only engages when the rail genuinely outgrows the
// viewport (bio expanded plus every in-progress badge shown), which beats
// clipping the bottom card off-screen with no way to reach it.
export const ProfileRail = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  position: 'sticky',
  top: theme.spacing(11),
  maxHeight: `calc(100vh - ${theme.spacing(13)})`,
  overflowY: 'auto',
  // Hide the rail's own scrollbar - a second bar beside the page's reads as a
  // glitch, and the rail only overflows in the expanded case.
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
  [theme.breakpoints.down('md')]: {
    position: 'static',
    maxHeight: 'none',
    overflowY: 'visible',
  },
}))
